import { useContext } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import useDetailsAction from "../actions/details/useDetailsAction";

function CategoriesPage() {
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  let { leagueId } = useParams();

  if (!leagueId) {
    leagueId = "0";
  }

  const filters = { league_id: parseInt(leagueId) };
  const formDefaultValues = { league_id: parseInt(leagueId) };

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  const { detailsFunction } = useDetailsAction(0);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getConfig({
    initializeFunction, // We pass the function to initialize a new element (used in the create button)
    indexFunction, // We pass the function to index the table
    getFunction, // We pass the function to get an element (used in the edit button)
    prepareRemoveFunction,
    detailsFunction,
    /**newActionsTableConfig**/
  });
  setTableConfig(tableConfig);

  const goToLeagues = () => {
    navigate(`/panel/leagues`);
  };

  return (
    <>
      <div className="breadcrum mb-3">
        <a href="javascript:;" onClick={goToLeagues}>
          Ligas
        </a>{" "}
        {">"} <a href="javascript:;">Categorías</a>
      </div>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between ps-3 text-bg-primary">
          <span>{t("categories")}</span>
          <div>
            <BeelditTableHeaderActions
              actions={tableConfig.actions}
            ></BeelditTableHeaderActions>
          </div>
        </Card.Header>

        <Card.Body>
          {listActionTemplate}
          {createActionTemplate}
          {editActionTemplate}
          {removeActionTemplate}
          {/* newTemplateActions */}
        </Card.Body>
      </Card>
    </>
  );
}

export default CategoriesPage;
